import { Card, CardBody } from '@vnetwork/ui/primitives';
import { InfoGrid } from '@/pages/account/components/InfoGrid';
import type { EmployeeRecord } from '@/api/employees';

interface Props { emp: EmployeeRecord }

/**
 * Experience tab — education (university / major) and work experience.
 * Matches the legacy Update/TabComponents/Experience panel.
 */
export function EmployeeTabExperience({ emp }: Props) {
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <Card flat>
        <CardBody>
          <p style={{
            margin: '0 0 var(--vn-space-3)',
            fontSize: 'var(--vn-font-size-sm)',
            fontWeight: 'var(--vn-font-weight-semibold)',
            color: 'var(--vn-fg-default)',
          }}>
            Education
          </p>
          <InfoGrid
            items={[
              { label: 'University', value: emp.employee_university },
              { label: 'Major', value: emp.employee_major },
            ]}
          />
        </CardBody>
      </Card>

      <Card flat>
        <CardBody>
          <p style={{
            margin: '0 0 var(--vn-space-3)',
            fontSize: 'var(--vn-font-size-sm)',
            fontWeight: 'var(--vn-font-weight-semibold)',
            color: 'var(--vn-fg-default)',
          }}>
            Work experience
          </p>
          <div style={{ fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-default)', whiteSpace: 'pre-wrap' }}>
            {emp.employee_experience || '—'}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
